import { CallerIdState } from '../types';

export const removeAllCallerId = (state: CallerIdState) => ({
  ...state,
  callerIds: [],
  lastSelectedCallerId: '',
});
